import {styled} from '@mui/system'

export const AnalyticsStyled = styled('div')(({theme}) => ({
  '.toolbar': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(4),
    marginBottom: theme.spacing(6)
  },

  '.sectionContent': {
    display: 'grid',
    gap: theme.spacing(6),
    paddingTop: theme.spacing(6)
  },

  '.totals': {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: theme.spacing(4),

    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr'
    }
  },

  '.totalItem': {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(3, 4),
    border: '1px solid #EEE',
    borderRadius: theme.spacing(2)
  },

  '.charts': {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: theme.spacing(6),

    [theme.breakpoints.down('lg')]: {
      gridTemplateColumns: '1fr'
    }
  },

  '.loader': {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(12, 0)
  },

  '.emptyMessage': {
    padding: theme.spacing(8, 0),
    textAlign: 'center'
  }
}))
